<template>
<inertia-head title="Bo Sanchez FREE Book - Multiple Income Streams" />
<div class="bg-trc-main">
	<div class="bg-black-25">
		<div class="content text-center">
			<div class="py-0 mb-3">
				<h2 class="fw-bold text-white mb-2">
				Join Bro Bo in a FREE Webinar!
				</h2>
				<h1 class="fw-bold text-white mb-2">
				Unlock Financial Freedom<br>
				Truly Rich Club Roadmap to Financial Success
				</h1>
				
			</div>
		</div>
	</div>
</div>
<div class="content">
	<div class="row justify-content-center">
		<div class="col-sm-12 col-md-10 col-lg-8">
			<img src="/media/images/webinar001.jpg" alt="" class="img-fluid mb-2">
		</div>
		<div class="col-sm-12 col-md-10 col-lg-8">
			<p>Do you want to have financial freedom? Do you have goals and dreams that you want to happen but the lack of financial resources fail you? You’ve come to the right place!</p>
			<p>Join us for an electrifying webinar titled "Unlock Financial Freedom: Truly Rich Club Roadmap to Financial Success" featuring the one and only Bro. Bo Sanchez!</p>
			<p><strong>Why should you watch this Webinar?</strong></p>
			<ul>
				<li>Discover how the Truly Rich Club helps good people like you become wealthy.</li>
				<li>Learn the 6 Essential Steps to investing in the stock market with confidence.</li>
				<li>Uncover the power of your "unfair" advantage and how to leverage it for financial success.</li>
				<li>Understand the importance of being part of a supportive community for sustained financial growth.</li>
			</ul>
			<p>
				Thousands of people have already joined this webinar and started their journey to financial freedom—now it's your turn! And here's the best part: <strong>It's completely FREE, but only for a limited time!</strong> This is a limited-time event, and we're opening the doors only for a short while. Don’t miss this opportunity to gain valuable insights from Bro. Bo Sanchez and begin your path to financial independence.
			</p>

			<p>Simply sign up using the form below, and we'll send you the link to the webinar right away. It's that easy!</p>

		</div>
		<div class="col-sm-12 col-md-10 col-lg-8 mt-5">
			<h2 class="text-center">Fill out the details below!</h2>
			<h4 class="text-center">Please ensure you provide a valid email address so we can send you the video link.</h4>
			<h1 class="text-center"><i class="fa fa-arrow-down"></i></h1>
			<div class="block block-rounded shadow">
				<div class="block-content block-content-full">
					<div class="form-group mb-3">
						<label>First Name</label>
						<input type="text" v-model="form.fname" name="fname" class="form-control" />
						<span v-if="form.errors.fname" class="text-danger">{{form.errors.fname}}</span>
					</div>
					<div class="form-group mb-3">
						<label>Last Name</label>
						<input type="text" v-model="form.lname" name="lname" class="form-control" />
						<span v-if="form.errors.lname" class="text-danger">{{form.errors.lname}}</span>
					</div>
					<div class="form-group mb-3">
						<label>Email Address</label>
						<input type="text" v-model="form.email" name="email" class="form-control" />
						<span v-if="form.errors.email" class="text-danger">{{form.errors.email}}</span>
					</div>
					<div class="form-group mb-3">
						<label>Mobile</label>
						<vue-tel-input
						@input="onInput"
						@countryChanged="onCountryChange"
						v-model="form.mobile"
						:value="form.mobile"
						class="form-control"
						:class="{ 'is-invalid': form.errors.mobile }"
						:input-options="{
						placeholder: 'Enter mobile number',
						}"
						:defaultCountry="form.country_code"
						mode="international"
						/>
						<span v-if="form.errors.mobile" class="text-danger">{{form.errors.mobile}}</span>
					</div>
					<div class="form-group mt-4 text-center">
						<button @click="claimBook" type="button" class="btn btn-success btn-lg" :disabled="form.processing">
						<div
							v-if="form.processing"
							class="spinner-border spinner-border-sm text-white me-1"
							role="status"
							>
							<span class="sr-only">Loading...</span>
						</div>
						<i v-else class="fa fa-plus me-1"></i>
						Register Now!
						</button>
					</div>
					
				</div>
			</div>
			<div class="block-content block-content-full">
				<p class="text-gray-dark"></p>
			</div>
			<div class="block-content block-content-full">
				<p class="text-center">Your referring affiliate is: {{affiliate_name}}</p>
			</div>
		</div>
	</div>
</div>
<!-- Footer -->
<footer id="page-footer">
	<div class="content py-3">
		<div class="row fs-sm">
			<div class="col-sm-12 order-sm-1 py-1 text-center">
				<a class="fw-semibold" href="#!">{{ $page.props.app.name }}</a>
				&copy; <span data-toggle="year-copy"></span>
			</div>
		</div>
	</div>
</footer>
</template>
<script>
	import GuestLayout from '../Layouts/FreeBookLayout';
	import { watch, ref, onMounted } from 'vue'
	import { useForm } from '@inertiajs/inertia-vue3'
	import { Inertia } from '@inertiajs/inertia';
	export default{
		layout: GuestLayout,
		props:{
												flash 			: Object,
									affiliate		: Number,
						affiliate_name	: String,
		},
		setup(props){
			const form = useForm({
										fname 		: '',
										lname 		: '',
										email 		: '',
				country_calling_code: '63',
				country_code: '',
										mobile		: '',
							affiliate 	: props.affiliate
			})
			const onInput = (number, phoneObject) => {
				if (phoneObject?.formatted) {
																	form.mobile 				= phoneObject.number;
								form.country_calling_code 	= phoneObject.countryCallingCode;
				}
				if(phoneObject.formatted=='')
				{
					form.mobile = '';
				}
			}
			const onCountryChange = (countryObject) => {
				form.country_code = countryObject.iso2
			}
			const claimBook = ()=>{
				form.post(route("post.webinar"),{
					only:['flash','errors','affiliate','affiliate_name'],
					onSuccess:()=>{
						form.fname='';
						form.lname='';
						form.email='';
						form.country_calling_code='63';
						form.country_code='';
						form.mobile='';
					}
				});
			}
			// watch(
						// 	() => props.flash,
						// 	(flash) => {
									// 		if (flash && flash.toast) {
												// 			if(flash.toast.type=='success')
												// 			{
															// 				Inertia.get("c/webinar/thankyou");
												// 			}
						
									// 		}
						// 	}
			// )
			return {
				form,
				onInput,
				onCountryChange,
				claimBook
			}
		}
	}
</script>